import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("surface-window")
export class SurfaceWindow extends LitElement {
  @property() heading = "";

  static styles = css`
    :host {
      position: relative;
      display: block;
      margin-bottom: 18px;
    }

    cpl-a2k-window {
      display: block;
      width: 100%;
      --window-width: 100%;
    }

    .surface-body {
      display: block;
      padding: 14px;
    }
  `;

  render() {
    return html`
      <cpl-a2k-window heading=${this.heading} ?draggable=${false} layout="flow">
        <div class="surface-body"><slot></slot></div>
      </cpl-a2k-window>
    `;
  }
}
